import { Flex, Badge, FlexProps } from '@chakra-ui/react';
import { ProductApprovalRejectReason } from '@texas/api/endpoints/productApprovalsApi';
import { convertToEnum } from '@texas/utils/helpers/enumHelpers';
import { useTranslation } from 'react-i18next';
import { rejectReasonAsFriendlyName } from '../shared';

export interface RejectReasonProps extends FlexProps {
  reasons: ProductApprovalRejectReason[] | null;
}
export function RejectReasons({ reasons, ...props }: RejectReasonProps) {
  const { t } = useTranslation();
  if (!reasons) return null;

  const friendlyReasons = reasons.map((r) =>
    rejectReasonAsFriendlyName(
      t,
      convertToEnum(ProductApprovalRejectReason, r),
    ),
  );
  return (
    <Flex display="inline-flex" gap={1} flexWrap="wrap" {...props}>
      {friendlyReasons.map((x, i) => (
        <Badge key={i}>{x}</Badge>
      ))}
    </Flex>
  );
}
